var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 341.33,
    style: {
      fill: "#FF4B55"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    style: {
      fill: "#41479B"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M85.689,306.389c-13.341,0-24.775-8.038-29.814-19.518c-0.003,0.175-0.052,0.337-0.052,0.513   c0,16.494,13.371,29.865,29.865,29.865s29.865-13.371,29.865-29.865c0-0.175-0.049-0.337-0.052-0.512   C110.464,298.352,99.029,306.389,85.689,306.389z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9CF02"
    },
    cx: 85.69,
    cy: 279.24,
    r: 21.72
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M72.114,238.513c0,7.497,6.078,13.575,13.575,13.575s13.575-6.078,13.575-13.575   c0-5.43-3.394-6.109-3.394-8.145c0-2.036,2.036-4.751-2.036-8.145c2.036,3.394-1.358,4.073-1.358,7.466   c0,3.394,1.358,3.394,1.358,6.109c0,1.499-1.216,2.715-2.715,2.715c-1.499,0-2.715-1.216-2.715-2.715   c0-2.715,2.715-5.43,2.715-9.503s-0.679-5.43-2.715-8.824c-2.036-3.394-5.43-6.109-2.715-8.824   c-4.073,1.358-2.036,6.788-2.036,10.181c0,3.394-2.715,5.43-2.715,9.503c0,4.073,2.036,4.751,2.036,7.466   c0,1.499-1.216,2.715-2.715,2.715c-1.499,0-2.715-1.216-2.715-2.715c0-2.715,1.358-2.715,1.358-6.109s-3.394-4.073-1.358-7.466   c-4.073,3.394-2.036,6.109-2.036,8.145C75.508,232.405,72.114,233.083,72.114,238.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M25.959,324.921v125.838c0,1.238,1.004,2.242,2.242,2.242h22.667c1.238,0,2.242-1.004,2.242-2.242   V324.921c0-1.238-1.004-2.242-2.242-2.242H28.2C26.962,322.679,25.959,323.683,25.959,324.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M118.269,324.921v125.838c0,1.238,1.004,2.242,2.242,2.242h22.667c1.238,0,2.242-1.004,2.242-2.242   V324.921c0-1.238-1.004-2.242-2.242-2.242h-22.667C119.273,322.679,118.269,323.683,118.269,324.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M58.539,346.641v6.377c0,1.238,1.004,2.242,2.242,2.242h49.817c1.238,0,2.242-1.004,2.242-2.242   v-6.377c0-1.238-1.004-2.242-2.242-2.242H60.78C59.542,344.399,58.539,345.403,58.539,346.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M58.539,422.661v6.377c0,1.238,1.004,2.242,2.242,2.242h49.817c1.238,0,2.242-1.004,2.242-2.242   v-6.377c0-1.238-1.004-2.242-2.242-2.242H60.78C59.542,420.42,58.539,421.423,58.539,422.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M62.585,322.679h46.208c1.137,0,1.551,1.497,0.577,2.082l-21.951,13.17   c-1.065,0.639-2.395,0.639-3.46,0l-21.951-13.17C61.034,324.176,61.449,322.679,62.585,322.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M62.585,436.71h46.208c1.137,0,1.551,1.497,0.577,2.082l-21.951,13.17   c-1.065,0.639-2.395,0.639-3.46,0l-21.951-13.17C61.034,438.207,61.449,436.71,62.585,436.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M88.341,360.901c-0.856-0.082-1.685-0.259-2.562-0.259c-14.931,0-27.077,12.147-27.077,27.077   c0,8.862,4.329,16.662,10.943,21.583c0.761,0.567,1.767-0.252,1.397-1.126c-0.794-1.879-1.239-3.938-1.239-6.106   c0-8.825,7.194-16.002,16.026-15.975c4.643,0.014,9.094-2.279,11.149-6.443C101.229,371.041,96.041,362.481,88.341,360.901z    M85.779,378.784c-2.991,0-5.416-2.424-5.416-5.416c0-2.991,2.425-5.415,5.416-5.415s5.415,2.424,5.415,5.415   C91.194,376.36,88.769,378.784,85.779,378.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CF02"
    },
    d: "M101.912,366.136c-0.761-0.567-1.767,0.252-1.397,1.126c0.794,1.879,1.239,3.938,1.239,6.106   c0,8.826-7.195,16.003-16.027,15.976c-4.643-0.015-9.095,2.279-11.149,6.443c-4.249,8.612,0.938,17.172,8.638,18.751   c0.856,0.082,1.685,0.259,2.562,0.259c14.93,0,27.077-12.147,27.077-27.078C112.856,378.857,108.526,371.058,101.912,366.136z    M85.779,407.486c-2.991,0-5.416-2.424-5.416-5.416c0-2.991,2.425-5.415,5.416-5.415s5.415,2.424,5.415,5.415   S88.769,407.486,85.779,407.486z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/mn.d1860cfe1f1d8f8ef1e6f70becfbe0ab.svg";
export { ForwardRef as ReactComponent };